export const GET_MY_FUNDS_ACTION = "/app/SearchAllocator/GET_MY_FUNDS_ACTION";
export const GET_MY_FUNDS_REQUEST = "/app/SearchAllocator/GET_MY_FUNDS_REQUEST";
export const GET_MY_FUNDS_SUCCESS = "/app/SearchAllocator/GET_MY_FUNDS_SUCCESS";
export const GET_MY_FUNDS_FAILED = "/app/SearchAllocator/GET_MY_FUNDS_FAILED";
